import store from '@/utils/store';
import {
    getUser
} from '@/api/user'
import {
    classify
} from "@/api/classify";
import {
    locationList
} from "@/api/location";
import cache from "@/utils/cache";

const actions = {
    // 获取定位数据
    locationList(context, isReLoad = false) {
        store.loadCacheData(context, 'locationList', locationList);
    },
    // 获取汽车商城分类
    classifyList(context, isReLoad = false) {
        store.loadCacheData(context, 'classifyList', classify);
    },
    // 获取用户信息
    userInfo(context, isReLoad = false) {
        // 如果没有登录,请求用户数据
        if (!context.state.userInfo || isReLoad) {
            store.loadCacheData(context, 'userInfo', getUser, null, {
                isReLoad: isReLoad
            });
        }
    },
    chinaAddress(context) {
        // 如果没有登录,请求用户数据
        if (!context.state.chinaAddress) {
            cache.getJson("./json/chinaAddress.json", "chinaAddress").then(data => {
                context.commit('chinaAddress', data);
            });
        }
    }
}
export default actions